function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.901961%,34.901961%,34.901961%)",
      fillOpacity: 1
    },
    d: "M 0.824219 6.523438 C -0.828125 9.183594 0.222656 13.226562 2.054688 15.675781 C 2.964844 16.902344 3.890625 18 5.160156 18 C 5.183594 18 5.207031 18 5.230469 18 C 5.828125 17.976562 6.257812 17.808594 6.671875 17.644531 C 7.140625 17.457031 7.621094 17.265625 8.378906 17.265625 C 9.101562 17.265625 9.558594 17.453125 10.003906 17.628906 C 10.441406 17.804688 10.894531 17.988281 11.5625 17.976562 C 12.988281 17.953125 13.863281 16.765625 14.636719 15.71875 C 15.445312 14.625 15.847656 13.566406 15.984375 13.160156 L 15.992188 13.144531 C 16.019531 13.070312 15.980469 12.992188 15.90625 12.960938 C 15.90625 12.960938 15.898438 12.957031 15.894531 12.957031 C 15.644531 12.859375 13.4375 11.953125 13.414062 9.484375 C 13.394531 7.476562 15.070312 6.414062 15.40625 6.21875 L 15.421875 6.210938 C 15.457031 6.1875 15.484375 6.15625 15.492188 6.113281 C 15.5 6.074219 15.492188 6.035156 15.464844 6 C 14.308594 4.433594 12.539062 4.195312 11.824219 4.167969 C 11.722656 4.160156 11.613281 4.152344 11.507812 4.152344 C 10.667969 4.152344 9.867188 4.449219 9.222656 4.683594 C 8.777344 4.847656 8.390625 4.988281 8.125 4.988281 C 7.828125 4.988281 7.441406 4.84375 6.992188 4.679688 C 6.394531 4.460938 5.714844 4.210938 4.996094 4.210938 C 4.980469 4.210938 4.960938 4.210938 4.945312 4.210938 C 3.273438 4.234375 1.695312 5.117188 0.824219 6.523438 Z M 0.824219 6.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.901961%,34.901961%,34.901961%)",
      fillOpacity: 1
    },
    d: "M 11.445312 0 C 10.398438 0.0351562 9.144531 0.578125 8.394531 1.320312 C 7.757812 1.941406 7.136719 2.980469 7.300781 4.027344 C 7.308594 4.089844 7.371094 4.140625 7.449219 4.148438 C 7.519531 4.152344 7.59375 4.152344 7.664062 4.152344 C 8.6875 4.152344 9.789062 3.675781 10.542969 2.910156 C 11.335938 2.097656 11.734375 1.058594 11.613281 0.125 C 11.605469 0.0507812 11.527344 -0.00390625 11.445312 0 Z M 11.445312 0 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.fc83d153d8f95679f1153a0f75f01d24.svg";
export { ForwardRef as ReactComponent };